import { gql } from '@apollo/client';

export default class CompanyMutation {
    static ADD_WATERMARK = gql`
        mutation addWatermark(
            $name: String!,
            $file: Upload!
        ) {
            addWatermark(
                name: $name,
                file: $file
            ) {
                companyWatermarkId
                url
            }
        }
    `;

    static REMOVE_WATERMARK = gql`
        mutation removeWatermark(
            $companyWatermarkId: Int!
        ) {
            removeWatermark(
                companyWatermarkId: $companyWatermarkId
            )
        }
    `;

    static UPDATE_COMPANY = gql`
        mutation updateCompany(
            $company: CompanyUpdate!
        ) {
            updateCompany(company: $company)
        }
    `;

    static UPDATE_PLAID_SETTING = gql`
        mutation updatePlaidSetting($plaidClientId: String, $plaidSecretKey: String) {
            updatePlaidSetting(plaidClientId: $plaidClientId, plaidSecretKey: $plaidSecretKey)
        }
    `;

    static UPDATE_SECURE_CLOSE_SETTING = gql`
        mutation updateSecureCloseSetting($secureCloseDmsguid: String, $secureCloseEnabled: Boolean) {
            updateSecureCloseSetting(secureCloseDmsguid: $secureCloseDmsguid, secureCloseEnabled: $secureCloseEnabled)
        }
    `;

    static ADD_COMPANY_LOGO = gql`
        mutation addCompanyLogo(
            $file: Upload!
        ) {
            addCompanyLogo(
                file: $file
            )
        }
    `;

    static REMOVE_COMPANY_LOGO = gql`
        mutation removeCompanyLogo{
            removeCompanyLogo
        }
    `;

    static UPDATE_COMPANY_THEME = gql`
        mutation updateCompanyTheme($input: [UpdateCompanySetting!]!) {
            updateCompanyTheme(input: $input)
        }
    `;

    static CREATE_COMPANY_THEME = gql`
        mutation createCompanyTheme($input: [InputCompanySetting!]!) {
            createCompanyTheme(input: $input)
        }
    `;

    static UPDATE_COMPANY_CARFAX = gql`
    mutation updateCompanyCarfax($input: Boolean!) {
        updateCompanyCarfax(input: $input)
    }
    `;

    static SAVE_COMPANY_SETTINGS = gql`
        mutation saveCompanySettings(
            $category: String!,
            $key: String!,
            $value: String!
        ) {
            saveCompanySettings(
                category: $category,
                key: $key,
                value: $value
            )
        }
    `;

    static UPDATE_COMPANY_MANHEIM = gql`
        mutation updateCompanyManheim($input: InputCompanyManheim!) {
            updateCompanyManheim(input: $input)
        }
    `;
}
